module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.52d37fb1.woff2";